export default __webpack_public_path__ + "static/media/ppcHero.53425528.jpg";